export { default } from './link-badge';
